module.exports = __webpack_public_path__ + "img/copy.5bce576f.svg";